import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-freight-rate-type',
  templateUrl: './freight-rate-type.component.html',
  styleUrls: ['./freight-rate-type.component.css']
})
export class FreightRateTypeComponent implements OnInit {
    freightRateTypeKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.freightRateTypeKeyno = this.stateService.getStateParams()['freightratetype_keyno'];
    }

    private async loadEdit() {
        if (!!this.freightRateTypeKeyno) {
            this.edit = (await this.datatask.Post(1537, { freightratetype_keyno: this.freightRateTypeKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1538, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    freightratetype_keyno: number;
    freightratetype_name: string;
    volume_m3: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('freightRateType', {
//        templateUrl: 'views/components/views/freightRateType/freightRateType.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'freightRateTypeService', function ($stateParams, stateService, translateService, modalService, freightRateTypeService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let freightRateTypeKeyno = $stateParams.freightratetype_keyno;

//            let translations = {
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadEdit() {
//                vm.model.edit = (await freightRateTypeService.getEdit({ freightratetype_keyno: freightRateTypeKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                freightRateTypeService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: function (dialogItself) {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
